import type { Translations } from "./sl";
import { FAQ_RU } from "@/content/faqData";
import { legalRu } from "./legal-ru";
import { propertyChecksRu } from "./property-checks-ru";
import { supportingDocumentsRu } from "./supporting-documents";

export const ru: Translations = {
  common: {
    error: "Ошибка",
    cancel: "Отмена",
    send: "Отправить",
    sending: "Отправка...",
    or: "Или",
    and: "и",
    aptNo: "№",
    aptNoTitle: "Номер квартиры",
    toggleMenu: "Открыть меню",
    skipToContent: "Перейти к содержимому",
    language: "Язык",
  },
  announcement: {
    text: "Попробуйте бесплатно — предпросмотр отчёта для вашего адреса.",
    cta: "Начать",
    dismiss: "Закрыть уведомление",
  },
  header: {
    features: "Возможности",
    howItWorks: "Как это работает",
    pricing: "Цены",
    dashboard: "Личный кабинет",
    adminDashboard: "Панель администратора",
    signOut: "Выйти",
    login: "Войти",
    register: "Регистрация",
  },
  brand: {
    "startLabel": "Начните с адреса недвижимости",
    "searchCta": "Продолжить",
    "freeNote": "Бесплатный предпросмотр после подтверждения email.",
    "sampleLabel": "Пример отчёта",
    "sampleNote": "Вымышленные данные · пример содержания",
    "sampleType": "Квартира · Любляна",
    "estimate": "Ориентировочная оценка стоимости",
    "uncertainty": "Диапазон оценки · неопределённость",
    "sources": "Основания для оценки",
    "sourceSales": "Реальные сделки",
    "sourceRegistry": "Данные GURS",
    "sourceListings": "Сопоставимые объявления",
    "checks": "Что ещё проверить",
    "checkTitle": "Статус в земельной книге",
    "checkNote": "Проверьте собственника и обременения до подписания.",
    "sourceTitle": "Более прочная основа для вашего решения.",
    "sourceDescription": "Открытые реестры и рыночные данные в понятном виде. Наличие данных зависит от объекта.",
    "sourceGurs": "Данные о здании, помещении и участке",
    "sourceEtn": "Зарегистрированные сделки и динамика цен",
    "sourceZk": "Собственники и обременения при наличии выписки",
    "sourceAds": "Контекст текущих цен в объявлениях",
    "sampleCta": "Посмотрите, что входит в отчёт",
    "sampleDisclaimer": "Пример с вымышленными данными, не анализ этого адреса.",
    "featuresEyebrow": "Внутри отчёта",
    "featuresTitle": "От данных к ясной картине.",
    "featuresDescription": "Оценка вместе с её основаниями и вопросы, на которые ещё предстоит ответить.",
    "processTitle": "От адреса к следующему шагу.",
    "illustration": "Пример разницы цен",
    "included": "В каждом полном отчёте",
    "previewEyebrow": "Посмотрите ближе",
    "previewTitle": "Отчёт, который пригодится на деле.",
    "previewDescription": "Сохраните, обсудите с партнёром или возьмите на консультацию. Важные факты, основания и следующие шаги остаются вместе.",
    "previewPoints": [
      "Понятная оценка и её неопределённость",
      "Проверяемые основания и сопоставимые сделки",
      "Открытые риски и проверки до подписания"
    ],
    "previewLanguage": "Пример отчёта представлен на словенском языке.",
    "featureItems": [
      {
        "title": "Данные реестров GURS",
        "description": "Площади, год постройки, сведения о здании и участке, обобщённая стоимость."
      },
      {
        "title": "Реальные сделки",
        "description": "Сопоставимые зарегистрированные продажи поблизости, их цены и даты."
      },
      {
        "title": "Расположение и окружение",
        "description": "Местоположение объекта, доступность и особенности района."
      },
      {
        "title": "Оценка с объяснением",
        "description": "Ориентировочная стоимость, диапазон неопределённости и основания расчёта."
      },
      {
        "title": "Риски и следующие шаги",
        "description": "Чётко обозначенные открытые проверки и факты для обсуждения цены."
      },
      {
        "title": "Понятный PDF",
        "description": "Отчёт для сохранения, обсуждения с партнёром или консультации."
      }
    ]
  },
  hero: {
    badgeGurs: "Официальные данные GURS",
    badgeValidity: "Кредиты действуют 1 год",
    badgeReports: "100+ созданных отчётов",
    eyebrow: "Отчёты о недвижимости в Словении",
    titleLead: "Сначала факты.",
    titleHighlight: "Затем решение.",
    subtitle:
      "Разберитесь в цене, сравните реальные сделки и узнайте, что ещё нужно проверить. Всё в одном понятном отчёте.",
    tagline: "Независимый обзор открытых реестров и рыночных данных.",
    featureOfficialTitle: "Официальные данные",
    featureOfficialDesc:
      "Прямой доступ к последним официальным записям ETN, GURS и земельного кадастра.",
    featureMarketTitle: "Рыночный анализ и сравнения",
    featureMarketDesc:
      "Сравнение с прошлыми продажами и текущими объявлениями в окрестностях.",
    featureAiTitle: "Аргументы для переговоров",
    featureAiDesc:
      "PDF с инструкциями, как договориться о более низкой цене и какие риски проверить до подписания.",
    ctaOrder: "Заказать подробный отчёт",
    ctaPreview: "Посмотреть образец",
  },
  propertyNextStep: {
    "eyebrow": "Выбранный объект",
    "edit": "Изменить адрес",
    "previewTitle": "Начните с бесплатного предпросмотра",
    "previewNote": "Посмотрите данные GURS и краткий обзор результатов для этого адреса. Наша оценка стоимости и полный анализ доступны за платный кредит.",
    "noCard": "Один предпросмотр после подтверждения почты · карта не нужна",
    "signedInTitle": "Продолжить с этим объектом",
    "signedInNote": "Адрес будет заполнен в личном кабинете. Используйте доступные кредиты для предпросмотра или полного отчёта.",
    "fullTitle": "Полный отчёт для этого адреса",
    "fullNote": "Оценка стоимости с диапазоном, сопоставимые продажи, риски и следующие шаги. Объём зависит от доступных данных.",
    "fullCta": "Полный отчёт · {{price}}",
    "packagesNote": "1 кредит для этого объекта · пакеты для нескольких адресов ниже"
  },
  addressSearch: {
    incompleteAddress: "Введите название улицы или населённого пункта и номер дома.",
    addressLabel: "Адрес недвижимости",
    propertyTypeLabel: "Тип недвижимости",
    house: "Дом",
    apartment: "Квартира",
    placeholder: "Введите адрес (напр. Trubarjeva 10, Ljubljana)",
    ordering: "Заказ...",
    getReport: "Получить бесплатный отчёт",
    hintHouse: "Введите адрес интересующего Вас дома для оценки стоимости",
    hintApartment: "Введите адрес интересующей Вас квартиры для оценки стоимости",
    hintApartmentNo: " • Укажите номер квартиры",
    toastEnterAddress: "Введите адрес",
    toastEnterAddressDesc: "Пожалуйста, введите адрес недвижимости.",
    toastEnterApt: "Введите номер квартиры",
    toastEnterAptDesc: "Пожалуйста, введите номер квартиры.",
    suggestionsStatus: "{{count}} вариантов адреса. Выбирайте стрелками и подтвердите клавишей Enter.",
    suggestionsLabel: "Варианты адреса",
  },
  askingVsRealized: {
    eyebrow: "Цена объявления против реализованной",
    title: "Цена в объявлении — лишь начало.",
    askingLabel: "Что написано в объявлении",
    askingValue: "250 000 €",
    askingNote: "Ожидание продавца",
    realizedLabel: "За сколько продали соседнюю квартиру",
    realizedValue: "218 000 €",
    realizedNote: "Сколько кто-то действительно заплатил (реестр ETN)",
    question: "Цена в объявлении — ожидание. Цена сделки — зарегистрированный платёж.",
    answer:
      "Для оценки цены нужны сопоставимые реальные продажи, их даты и различия между объектами. Отчёт объединяет эти сведения и объясняет их значение и ограничения.",
    caveat:
      "Разница между ценой объявления и реализованной ценой — не весь переговорный простор: часть её объясняется различиями между сравниваемыми объектами и более широким географическим охватом объявлений. Подробнее в руководстве.",
    cta: "Узнать, какова разница и что она означает",
  },
  features: {
    eyebrow: "Возможности",
    title: "Что мы можем Вам предложить?",
    description:
      "Всё необходимое для более безопасного решения о покупке недвижимости — в одном месте.",
    items: [
      {
        title: "Официальные данные GURS",
        description:
          "Те же данные, что есть у продавца, — теперь на вашей стороне.",
      },
      {
        title: "Базовый рыночный анализ",
        description:
          "Увидите, за сколько на самом деле продавали недвижимость на вашей улице.",
      },
      {
        title: "Информация о локации",
        description:
          "Узнайте, что влияет на стоимость, — раньше, чем это узнает покупатель после вас.",
      },
      {
        title: "AI-оценка",
        description:
          "Компьютер объединяет 78+ показателей, на самостоятельное изучение которых у вас ушли бы недели.",
      },
      {
        title: "PDF-лист для переговоров",
        description:
          "Понятный PDF с обоснованными аргументами для снижения цены и конкретными шагами, которые нельзя пропускать до подписания.",
      },
      {
        title: "Понятный отчёт",
        description:
          "Понятный, хорошо структурированный PDF-отчёт, готовый к сохранению, отправке или обсуждению со специалистом.",
      },
    ],
  },
  howItWorks: {
    eyebrow: "Процесс",
    title: "Как это работает?",
    description:
      "Введите адрес, изучите доступные сведения и определите следующие шаги.",
    steps: [
      {
        title: "Введите данные",
        description: "Введите адрес недвижимости для анализа.",
      },
      {
        title: "AI анализирует несколько источников",
        description:
          "Рыночные цены, локация, сопоставимые продажи, риски и тренды.",
      },
      {
        title: "Получите отчёт",
        description:
          "Стоимость, предупреждения и рекомендации — понятно даже без экспертных знаний.",
      },
      {
        title: "Ведите переговоры с фактами",
        description:
          "Конкретные аргументы для снижения цены — подкреплённые официальными данными.",
      },
    ],
  },
  testimonials: {
    eyebrow: "Нам доверяют многие",
    title: "Что говорят наши пользователи",
    description:
      "Реальный опыт агентов, инвесторов и владельцев недвижимости по всей Словении.",
    items: [
      {
        name: "Marko",
        location: "Ljubljana",
        content:
          "Очень доволен nReport. Их AI-анализ близко соответствовал фактическим ценам продаж. Отличный сервис!",
      },
      {
        name: "Ana",
        location: "Ljubljana",
        content:
          "Как лицензированный агент, я теперь использую nReport для всех своих клиентов. Отчёты незаменимы — подробные, надёжные и профессионально подготовленные. Мои покупатели всегда впечатлены.",
      },
      {
        name: "Matej",
        location: "Maribor",
        content:
          "При оценке коммерческих помещений для расширения nReport сэкономил месяцы работы. Мы получили три оценки за одну неделю, все на основе официальных данных GURS. Инвестиция окупилась в первый же день.",
      },
      {
        name: "Petra",
        location: "Celje",
        content:
          "При разделе активов мне нужны надёжные оценки. nReport предоставляет именно это — профессиональные отчёты на основе официальных данных.",
      },
      {
        name: "Gregor",
        location: "Koper",
        content:
          "Рекомендую nReport клиентам для быстрой информационной оценки. В течение 24 часов они получают профессиональный отчёт, который помогает понять стоимость недвижимости. Отличный сервис!",
      },
    ],
    prevAria: "Предыдущий отзыв",
    nextAria: "Следующий отзыв",
    goToAria: "Перейти к отзыву",
  },
  pricing: {
    badge: "Выберите пакет",
    title: "Пакеты отчётов",
    subtitle: "Выберите пакет для вашего поиска. Каждый платный пакет включает полный отчёт.",
    subtitleHighlight:
      "1 кредит = 1 отчёт. Кредиты действительны 1 год с момента покупки.",
    popular: "Для сравнения вариантов",
    freePlan: {
      badge: "Бесплатно",
      name: "Бесплатный предпросмотр отчёта",
      subtitle: "1 сводка",
      priceLabel: "€0",
      specialNote: "После подтверждения электронной почты",
      features: [
        "Официальные данные GURS и кадастровая стоимость",
        "Число сделок и объявлений поблизости",
        "Открытые риски, которые стоит проверить до подписания",
      ],
      lockedNote:
        "Наша оценка стоимости и остальная часть отчёта (анализ рынка, локация, кадастр, сделки ETN) открываются покупкой 1 кредита",
      buttonText: "Попробовать бесплатно",
      buttonTextLoggedIn: "В личный кабинет",
    },
    addressWarning:
      'Адрес «{{address}}» не содержит номера дома. Пожалуйста, вернитесь и введите полный адрес с номером дома для покупки кредитов.',
    anchorAppraisalLabel: "Оценка судебного эксперта",
    anchorAppraisalValue: "400 – 600 €",
    anchorOursLabel: "Информационный отчёт nReport",
    anchorOursValue: "от 23,40 €",
    anchorNote:
      "Отчёт не заменяет официальную оценку — это более быстрая и дешёвая основа для решения, реалистична ли цена и стоит ли вообще заказывать оценку.",
    perReport: "/ отчёт",
    includesGurs: "Выписка GURS и проверка земельного кадастра (ZK) включены во все пакеты",
    notOfficialAppraisal: "Информационный отчёт для более взвешенных решений — он не заменяет официальную оценку",
    selectAddressFirst: "Выберите адрес перед покупкой",
    aptPrefix: "кв.",
    securePayment: "100% безопасная оплата",
    securePaymentDesc: "через Stripe • Без скрытых комиссий",
    allCards: "💳 Все карты",
    instantActivation: "⚡ Мгновенная активация",
    toastAddressRequired: "Требуется адрес",
    toastAddressRequiredDesc:
      "Пожалуйста, выберите адрес недвижимости перед покупкой кредитов.",
    toastInvalidAddress: "Неверный адрес",
    toastInvalidAddressDesc:
      "Адрес должен содержать номер дома. Пожалуйста, введите полный адрес.",
    toastAptRequired: "Требуется номер квартиры",
    toastAptRequiredDesc:
      "Пожалуйста, введите номер квартиры перед покупкой кредитов.",
    plans: [
      {
        name: "Пакет 1",
        subtitle: "Получите 1 отчёт",
        features: [
          "Официальные данные GURS",
          "Сравнение рыночных цен (завершённые сделки + объявления)",
          "Проверка статуса земельного кадастра",
          "AI-оценка стоимости",
          "PDF-лист для переговоров с аргументами для снижения цены",
        ],
        buttonText: "Купить 1 кредит",
      },
      {
        name: "Пакет 2",
        subtitle: "2 отчёта",
        specialNote: "Идеально для сравнения нескольких объектов",
        features: [
          "PDF-лист для переговоров с аргументами для снижения цены",
          "Всё из пакета 1",
          "Экономия 20% на отчёт",
        ],
        buttonText: "Купить 2 кредита",
      },
      {
        name: "Пакет 3",
        subtitle: "5 отчётов",
        specialNote: "Самая низкая цена за отчёт",
        features: [
          "PDF-лист для переговоров с аргументами для снижения цены",
          "Всё из пакета 1",
          "Экономия 40% на отчёт",
        ],
        buttonText: "Купить 5 кредитов",
      },
    ],
    buy: "Купить",
  },
  faq: {
    eyebrow: "Помощь",
    title: "Часто задаваемые вопросы",
    description:
      "Ответы на наиболее распространённые вопросы о наших отчётах о недвижимости.",
    contactTitle: "Есть вопрос?",
    contactDesc: "Напишите нам, и мы с радостью поможем.",
    contactCta: "Отправить вопрос",
    items: FAQ_RU,
  },
  ratingStats: {
    eyebrow: "Удовлетворённость",
    title: "Удовлетворённость наших пользователей",
    description:
      "Оценки и рекомендации в реальном времени от пользователей, которые уже получили отчёт.",
    recommend: "пользователей рекомендуют нас",
    averageRating: "средняя оценка",
    votes: "голосов",
  },
  footer: {
    tagline:
      "Независимые отчёты о недвижимости в Словении. Понятные факты, основания и следующие шаги.",
    legalHeading: "Правовая информация",
    terms: "Условия использования",
    privacy: "Политика конфиденциальности",
    cookies: "Cookie",
    dataDeletion: "Удаление данных",
    cookieSettings: "Настройки файлов cookie",
    trustedSources: "Надёжные источники",
    trustedSourcesDesc:
      "Открытые реестры и рыночные данные в одном отчёте. Наличие отдельных сведений и выписок зависит от объекта.",
    copyright: "© 2026 Noventis d.o.o. Все права защищены.",
    slogan: "nReport.ai — более осознанная покупка недвижимости",
    backToTop: "Наверх",
  },
  newsletter: {
    heading: "Рассылка nReport",
    description:
      "Аналитика рынка недвижимости, новые руководства и обновления. Раз в месяц, без спама.",
    placeholder: "vy@email.com",
    submit: "Подписаться",
    success: "Спасибо! Вы подписаны на рассылку.",
    error: "Не удалось подписаться. Попробуйте ещё раз.",
    invalidEmail: "Введите действительный адрес электронной почты.",
    privacy: "Отписаться можно в любой момент.",
    optIn: "Хочу получать новости рынка недвижимости (отписка в любой момент).",
  },
  sampleExplorer: {
    loadError: "Не удалось загрузить обзор. Вы всё ещё можете скачать полный пример.",
    loading: "Открываем пример…",
    "title": "Изучите пример отчёта",
    "description": "Краткий обзор оценки, данных и открытых вопросов. Это вымышленный пример; полный PDF — на словенском языке.",
    "close": "Закрыть пример",
    "sections": "Разделы примера",
    "value": "Стоимость",
    "evidence": "Данные",
    "checks": "Проверки",
    "valueTitle": "Цене нужен контекст.",
    "valueNote": "Оценка — отправная точка для анализа запрашиваемой цены. Диапазон показывает неопределённость; одна цифра не заменяет осмотр или профессиональную оценку.",
    "salesNote": "Зарегистрированные продажи показывают фактически уплаченные цены, даты и сопоставимые объекты.",
    "registryNote": "Площадь, год постройки и идентификаторы помогают определить, какие объекты вы сравниваете.",
    "listingsNote": "Текущие объявления отражают ожидания продавцов. Запрашиваемая цена не равна цене состоявшейся продажи.",
    "askingPrices": "Цены в объявлениях",
    "availability": "Доступность источников и сопоставимых данных зависит от объекта.",
    "checkTitle": "Понимайте, что ещё нужно проверить.",
    "checkNote": "Чётко обозначенные открытые вопросы помогают спланировать действия до подписания. Доступная выписка из земельного реестра служит основой для проверки собственности и обременений.",
    "openPdf": "Открыть полный PDF",
    "back": "Назад к обзору",
    "price": "1 полный отчёт · {{price}}",
    "cta": "Выбрать отчёт"
  },
  pdfPreview: {
    title: "Образец отчёта nReport",
    download: "Скачать PDF",
    downloadShort: "Скачать",
    orderReport: "Заказать отчёт",
    iframeTitle: "Образец PDF-отчёта",
  },
  contact: {
    eyebrow: "Контакты",
    title: "Отправьте нам вопрос",
    description:
      "Заполните форму, и мы свяжемся с Вами как можно скорее.",
    nameLabel: "Полное имя",
    namePlaceholder: "Иван Иванов",
    emailLabel: "Адрес электронной почты",
    emailPlaceholder: "ivan@example.com",
    messageLabel: "Ваш вопрос",
    messagePlaceholder: "Опишите Ваш вопрос...",
    successTitle: "Сообщение отправлено",
    successDesc:
      "Спасибо за Ваш вопрос. Мы ответим как можно скорее.",
    errorSend: "Не удалось отправить сообщение. Пожалуйста, попробуйте снова.",
    validation: {
      nameRequired: "Имя обязательно",
      nameTooLong: "Имя слишком длинное",
      emailInvalid: "Неверный адрес электронной почты",
      emailTooLong: "Адрес электронной почты слишком длинный",
      messageRequired: "Сообщение обязательно",
      messageTooLong: "Сообщение слишком длинное",
    },
  },
  auth: {
    signedOutTitle: "Вы вышли",
    signedOutDesc: "Вы успешно вышли из аккаунта.",
    signOutError: "Не удалось выйти. Попробуйте ещё раз.",
    login: "Вход",
    register: "Регистрация",
    loginDesc: "Войдите, чтобы получить доступ к кредитам и отчётам.",
    registerDesc:
      "Создайте учётную запись для покупки кредитов и доступа к отчётам. После подтверждения почты вы получите бесплатный кредит на предпросмотр отчёта.",
    displayName: "Отображаемое имя",
    displayNamePlaceholder: "напр. Иван Иванов",
    email: "Электронная почта",
    password: "Пароль",
    showPassword: "Показать пароль",
    hidePassword: "Скрыть пароль",
    legalNotice: "Регистрируясь, вы принимаете",
    legalTerms: "Общие условия",
    legalPrivacy: "Политику конфиденциальности",
    passwordHint:
      "Пароль должен содержать не менее 8 символов, включая заглавные и строчные буквы, а также цифру.",
    loginSubmit: "Войти",
    registerSubmit: "Зарегистрироваться",
    loginWithGoogle: "Войти через Google",
    registerWithGoogle: "Зарегистрироваться через Google",
    loginWithFacebook: "Войти через Facebook",
    registerWithFacebook: "Зарегистрироваться через Facebook",
    noAccount: "Нет учётной записи? Зарегистрируйтесь",
    hasAccount: "Уже есть учётная запись? Войдите",
    invalidEmail: "Введите действующий адрес электронной почты",
    forgotPassword: "Забыли пароль?",
    resetEnterEmail: "Сначала введите свой адрес электронной почты.",
    resetSentTitle: "Ссылка для сброса отправлена",
    resetSentDesc: "Проверьте почту — мы отправили ссылку для сброса пароля.",
    resetError: "Не удалось отправить ссылку для сброса. Попробуйте ещё раз.",
    recoveryTitle: "Установите новый пароль",
    recoveryDesc: "Выберите новый пароль для своей учётной записи.",
    recoverySubmit: "Обновить пароль",
    passwordUpdatedTitle: "Пароль обновлён",
    passwordUpdatedDesc: "Теперь вы можете войти с новым паролем.",
    displayNameTooShort: "Отображаемое имя должно содержать не менее 2 символов",
    passwordTooShort: "Пароль должен содержать не менее 8 символов",
    passwordNeedsLower: "Пароль должен содержать хотя бы одну строчную букву",
    passwordNeedsUpper: "Пароль должен содержать хотя бы одну заглавную букву",
    passwordNeedsDigit: "Пароль должен содержать хотя бы одну цифру",
    invalidCredentials: "Неверные учётные данные",
    resendConfirmationTitle: "Письмо с подтверждением отправлено",
    resendConfirmationSent: "Проверьте почту — там должна быть новая ссылка для подтверждения.",
    resendConfirmationFailed: "Не удалось повторно отправить письмо с подтверждением. Пожалуйста, попробуйте через несколько минут.",
    userExists: "Пользователь с таким адресом электронной почты уже существует",
    weakPassword:
      "Этот пароль слишком распространён и легко угадывается. Пожалуйста, выберите более надёжный пароль.",
    registerSuccess: "Регистрация успешна",
    registerSuccessDesc:
      "Проверьте почту для подтверждения. После подтверждения вы получите бесплатный кредит на предпросмотр отчёта.",
    suspiciousActivity:
      "Обнаружена необычная активность. Пожалуйста, подождите несколько минут.",
    googleError: "Не удалось войти через Google. Пожалуйста, попробуйте снова.",
    facebookError: "Не удалось войти через Facebook. Пожалуйста, попробуйте снова.",
    redirectingToGoogle: "Перенаправление на Google...",
    completingSignIn: "Завершение входа...",
  },
  dashboard: {
    title: "Личный кабинет",
    loginPrompt: "Войдите, чтобы получить доступ к личному кабинету.",
    loadingSession: "Завершение входа...",
    welcome: "Добро пожаловать, {{name}}!",
    subtitle: "Ваши отчёты, кредиты и заказы — всё в одном месте.",
    orderTitle: "Заказать отчёт о недвижимости",
    orderDesc: "Введите адрес недвижимости для подготовки отчёта.",
    orderCta: "Заказать отчёт (1 кредит)",
    orderPaidCta: "Заказать подробный отчёт (1 кредит)",
    orderPreviewCta: "Получить бесплатный предварительный просмотр",
    orderPaidDesc: "Введите адрес недвижимости. Подробный отчёт использует 1 купленный кредит.",
    orderPreviewDesc: "У вас есть бесплатный кредит для предварительного просмотра отчёта. Для открытия подробного отчёта нужен купленный кредит.",
    insufficientCredits: "Недостаточно кредитов",
    insufficientCreditsDesc:
      "У Вас недостаточно действующих кредитов для заказа отчёта. Требуется 1 кредит.",
    insufficientCreditsShort:
      "У Вас недостаточно действующих кредитов для заказа отчёта.",
    orderError: "Ошибка при заказе отчёта",
    propertyNotFound: "Адрес не найден в кадастре",
    propertyNotFoundDesc:
      "Адрес не найден в реестре GURS. Проверьте номер дома и правильность адреса.",
    apartmentNotFound: "Квартира не найдена",
    apartmentNotFoundDesc:
      "Квартира с указанным номером не найдена по этому адресу в кадастре.",
    orderSuccess: "Отчёт заказан",
    orderSuccessDesc: "Ваш отчёт готовится.",
    orderHeldDesc: "Мы добавим выписку из земельной книги и пришлём отчёт на ваш e-mail в течение 1 рабочего дня.",
    genericError: "Что-то пошло не так. Пожалуйста, попробуйте снова.",
    statCredits: "Доступные кредиты",
    statInProgress: "В работе",
    statCompleted: "Завершённые отчёты",
    statInProgressInline: "{{count}} в работе",
    statCompletedInline: "{{count}} завершено",
    lowCreditsTitle: "У Вас закончились кредиты",
    lowCreditsDesc:
      "Купите кредиты ниже, чтобы заказать следующий отчёт о недвижимости.",
    creditHistoryToggle: "История кредитов",
    newReportEyebrow: "Новый отчёт",
    reportsEyebrow: "Ваши отчёты",
    loadError: {
      retry: "Повторить",
      unavailable: "Не загружено",
      hint: "Ваши данные не потеряны. Проверьте подключение и попробуйте ещё раз.",
      credits: "Не удалось загрузить баланс кредитов.",
      orders: "Не удалось загрузить ваши отчёты.",
      transactions: "Не удалось загрузить историю кредитов.",
    },
    expiringCredits: {
      title: "{count} кредитов скоро истекают",
      desc: "Ваши {count} неиспользованных кредитов истекают {date}. После этой даты воспользоваться ими будет нельзя, поэтому используйте их заранее.",
    },
    bulk: {
      addAddress: "Добавить в список",
      eyebrow: "Несколько объектов",
      title: "Заказать несколько отчётов сразу",
      desc: "Добавьте объекты в список и закажите их за один раз. Каждый отчёт стоит один кредит.",
      apartment: "Квартира №",
      duplicate: "Этот объект уже в списке.",
      remove: "Удалить из списка",
      placed: "Заказан",
      failed: "Не удалось",
      skippedNoCredits: "Не заказан — закончились кредиты.",
      needCredits: "{count} объектов в списке · у вас {balance} кредитов",
      partialWarning: "Будут заказаны первые {n}.",
      submit: "Заказать {count} отчётов",
      running: "Заказываю {done}/{total} …",
      doneTitle: "Заказ завершён",
      doneDesc: "Заказано {placed} из {total} отчётов.",
    },
  },
  checkout: {
    tagline: "Отчёты о недвижимости",
    back: "Назад",
    orderSummary: "Сводка заказа",
    unlockTitle: "Открытие отчёта",
    unlockDesc: "Кредит будет потрачен на открытие этого отчёта сразу после оплаты.",
    package: "Пакет",
    credits: "Кредиты",
    address: "Адрес",
    total: "Итого",
    includesVat: "Включая НДС",
    vatExempt: "Окончательная цена. НДС не начисляется (пункт 1 статьи 94 закона ZDDV-1).",
    securePaymentTitle: "Безопасная оплата",
    securePaymentDesc:
      "Ваши платёжные данные обрабатываются Stripe. Ваши данные в безопасности и зашифрованы.",
    creditsValidity: "1 кредит = 1 отчёт. Кредиты действительны 1 год с момента покупки.",
    paymentTitle: "Оплата",
    paymentDesc: "Завершите покупку с безопасной оплатой через Stripe",
    loadingPayment: "Загрузка платёжной системы...",
    legalTitle: "Правовое уведомление",
    legalDesc:
      "Отчёт предназначен исключительно для информационных целей и не является официальной оценкой недвижимости. Данные и анализы основаны на общедоступных записях и статистических моделях, которые не заменяют профессиональную оценку лицензированного оценщика.",
    missingData: "Отсутствуют необходимые данные для покупки. Пожалуйста, попробуйте снова.",
    paymentEyebrow: "Оплата",
    paymentSuccess: "Оплата прошла успешно!",
    redirecting: "Перенаправление...",
    creditOne: "кредит",
    creditTwo: "кредита",
    creditFew: "кредита",
    creditMany: "кредитов",
  },
  paymentSuccess: {
    processingEyebrow: "Оплата",
    processingTitle: "Подтверждаем оплату…",
    processingDesc: "Это займёт всего несколько секунд. Пожалуйста, не закрывайте страницу.",
    loginTitle: "Войдите, чтобы просмотреть статус оплаты",
    loginDesc: "Ваш платёж в безопасности. Войдите в аккаунт, с которого вы оплачивали, — и мы подтвердим кредиты прямо здесь.",
    successEyebrow: "Оплата подтверждена",
    successTitle: "Спасибо, оплата получена",
    successDesc: "Кредиты зачислены на ваш счёт и готовы к использованию.",
    paymentFailed: "Оплата не прошла",
    processingError: "Произошла ошибка при обработке Вашего заказа.",
    stepsLabel: "Ход заказа",
    stepPayment: "Оплата получена",
    stepPaymentActive: "Подтверждаем оплату…",
    stepCredits: "Кредиты зачислены",
    stepCreditsActive: "Зачисляем кредиты на ваш счёт…",
    stepCreditsDone: "Зачислено на ваш счёт: {{credits}}",
    stepCreditsWaiting: "Занимает больше времени, чем обычно, — кредиты будут зачислены автоматически.",
    stepOrder: "Отчёт запущен",
    stepOrderActive: "Запускаем отчёт по введённому адресу…",
    stepOrderDone: "Мы начали готовить отчёт по введённому адресу. Он скоро появится в вашем личном кабинете.",
    stepOrderFailed: "Не удалось запустить отчёт автоматически. Кредит остаётся у вас — закажите отчёт в личном кабинете.",
    stepUnlock: "Полный отчёт",
    stepUnlockActive: "Разблокируем ваш отчёт…",
    stepUnlockDone: "Полный отчёт готов к просмотру.",
    stepUnlockHeld: "Оплачено. Полный отчёт с выпиской из земельной книги доставим в течение 1 рабочего дня.",
    stepUnlockFailed: "Кредит остаётся у вас — разблокируйте отчёт одним нажатием на его странице.",
    stepNext: "Закажите отчёт",
    stepNextDesc: "Введите адрес недвижимости в личном кабинете. Каждый отчёт использует 1 кредит.",
    statusDone: "выполнено",
    statusActive: "выполняется",
    statusPending: "ожидает",
    statusNext: "следующий шаг",
    statusAttention: "требует внимания",
    delayedTitle: "Оплата получена, кредиты в пути",
    delayedDesc: "Оплата подтверждена, но зачисление кредитов занимает больше времени, чем обычно, — как правило, это решается в течение минуты. Проверьте ещё раз или откройте личный кабинет, где появятся кредиты.",
    checkAgain: "Проверить ещё раз",
    checkingAgain: "Проверяем…",
    errorTitle: "Пока не удалось подтвердить оплату",
    errorDesc: "Если деньги списаны, ваши кредиты в безопасности. Попробуйте ещё раз через минуту или напишите нам.",
    missingSessionTitle: "Не удаётся найти этот платёж",
    missingSessionDesc: "В ссылке нет идентификатора платежа. Если деньги списаны, кредиты появятся в вашем личном кабинете.",
    redirectDashboardIn: "Переход в личный кабинет через {{seconds}} с.",
    redirectReportIn: "Отчёт откроется через {{seconds}} с.",
    stayHere: "Остаться на этой странице",
    goToDashboard: "Перейти в личный кабинет",
    openReport: "Открыть отчёт",
    backHome: "Вернуться на главную",
    contactLead: "Есть вопросы? Напишите нам:",
    announceConfirming: "Подтверждаем оплату.",
    announceCompleted: "Оплата подтверждена. Зачислено на ваш счёт: {{credits}}.",
    guestTitle: "Платёж получен!",
    guestDesc: "Мы отправили вам ссылку для входа, чтобы получить доступ к кредитам на отчёты.",
    guestSpam: "Не видите письмо через несколько минут? Проверьте папку «Спам».",
  },
  postPurchaseSurvey: {
    question: "Короткий вопрос — что чуть не помешало вам купить?",
    options: {
      price: "Цена",
      trust: "Сомнения в точности данных",
      unclear: "Непонятно, что входит",
      technical: "Проблемы с оплатой/технические",
      nothing: "Ничего — всё было просто",
    },
    skip: "Пропустить",
    thanks: "Спасибо за отзыв!",
  },
  paymentTrust: {
    acceptedMethods: "Принимаем все основные карты",
    securedByStripe: "Безопасная оплата через Stripe",
    encryptedNote: "Данные вашей карты шифруются и никогда не попадают на наши серверы.",
  },
  checkoutSupport: {
    contact: "Связаться с поддержкой",
    cancellation: "14-дневное право на отказ",
  },
  checkoutSteps: {
    package: "Пакет",
    payment: "Оплата",
    done: "Подтверждение",
  },
  checkoutUpsell: {
    title: "Нужно больше одного?",
    desc: "{{credits}} отчётов за €{{price}} — всего €{{per}} за отчёт, на {{discount}}% дешевле.",
    cta: "Выбрать этот пакет",
  },
  paymentCanceled: {
    eyebrow: "Отменено",
    title: "Оплата отменена",
    desc: "Ваша оплата была отменена. Средства с Вашего счёта не списаны.",
    help: "Если произошла ошибка или у Вас возникли проблемы с оплатой, свяжитесь с нами для помощи.",
    backHome: "Вернуться на главную",
    tryAgain: "Попробовать снова",
    contact: "По вопросам оплаты обращайтесь к нам по адресу info@nreport.ai",
  },
  notFound: {
    eyebrow: "Ошибка 404",
    title: "Страница не найдена",
    desc: "К сожалению, запрашиваемая страница не существует или была перемещена.",
    backHome: "Вернуться на главную",
    goBack: "Назад",
  },
  errorBoundary: {
    eyebrow: "Ошибка",
    title: "Что-то пошло не так",
    desc: "Произошла непредвиденная ошибка. Попробуйте обновить страницу или обратитесь в поддержку.",
    retry: "Повторить",
    reload: "Обновить страницу",
    devDetails: "Информация для разработчика",
  },
  quickPurchase: {
    title: "Быстрая покупка кредитов",
    popular: "Популярный",
    packages: [
      { name: "Купить 1 кредит", description: "Один отчёт" },
      { name: "Купить 2 кредита", description: "Экономия 20%" },
      { name: "Купить 5 кредитов", description: "Экономия 40%" },
    ],
  },
  orderStatus: {
    title: "Мои отчёты",
    desc: "Скачайте готовые отчёты или отслеживайте отчёты в работе",
    noOrders: "Отчётов пока нет",
    noOrdersHint: "Закажите свой первый отчёт о недвижимости ниже.",
    defaultTitle: "Отчёт о недвижимости",
    apartment: "Квартира",
    house: "Дом",
    property: "Недвижимость",
    aptNo: "№",
    downloadPdf: "Скачать PDF",
    openPdf: "Открыть отчёт в новой вкладке",
    refresh: "Обновить заказы",
    loadMore: "Показать более ранние отчёты",
    loadingMore: "Загрузка более ранних отчётов …",
    loadedCount: "Показано отчётов: {{count}}",
    loadMoreError: "Не удалось загрузить более ранние отчёты. Попробуйте ещё раз.",
    dateUnknown: "Дата неизвестна",
    thumbnailAlt: "Предпросмотр карты для {{address}}",
    readyBadge: "Готово",
    previewBadge: "Предпросмотр",
    unlockHeldBadge: "Оплачено — готовится",
    hintCompleted: "Ваш отчёт готов к скачиванию.",
    hintProcessing: "Мы анализируем недвижимость — обычно это занимает несколько минут.",
    hintPending: "Ваш отчёт в очереди и скоро начнёт готовиться.",
    hintFailed: "Что-то пошло не так. Если проблема сохраняется, свяжитесь со службой поддержки.",
    hintRefunded: "Не удалось начать подготовку отчёта, поэтому ваш кредит возвращён. Вы можете заказать отчёт снова.",
    hintNeedsReview: "Автоматическая проверка качества обнаружила несоответствие, поэтому отчёт перед отправкой проверяется вручную. Мы сообщим вам, когда он будет готов.",
    hintAwaitingApproval: "Ваш отчёт готов, и перед отправкой мы ещё раз лично его проверяем. Вы получите его по электронной почте после утверждения.",
    statusUnknown: "Неизвестно",
    statusCompleted: "Завершено",
    statusProcessing: "Обработка",
    statusPending: "В очереди",
    statusFailed: "Ошибка",
    statusCancelled: "Отменено",
    statusNeedsReview: "На проверке",
    viewReport: "Просмотреть отчёт",
    generation: {
      live: "Онлайн",
      phaseQueued: "В очереди",
      phaseChecking: "Проверяем объект",
      phaseWriting: "Пишем анализ",
      phaseMarket: "Анализ рынка и проверка",
      phasePdf: "Формируем PDF",
      phaseDone: "Готово",
      etaMinutes: "ещё около {{count}} мин",
      etaUnderMinute: "меньше минуты",
      etaLonger: "Занимает больше времени, чем обычно — отчёт всё равно будет готов.",
      typicalDuration: "Обычно занимает около 3 минут.",
      heldTitle: "Получаем выписку из земельной книги",
      heldDesc: "Платный отчёт дополняется выпиской из земельной книги. Готовый отчёт мы пришлём на ваш e-mail в течение 1 рабочего дня.",
      activeTitle: "Отчёты в работе",
      activeDesc: "Следите за прогрессом в реальном времени. Ссылка на отчёт появится здесь, как только он будет готов.",
      viewAll: "Все отчёты",
      duplicateTitle: "У вас уже есть отчёт по этому адресу",
      duplicateDesc: "Заказ для {{address}} уже существует ({{status}}). Новый заказ потратит ещё один кредит и создаст второй отчёт по тому же объекту.",
      duplicateConfirm: "Всё равно заказать (1 кредит)",
      duplicateCancel: "Отмена",
    },
  },
  reportDetail: {
    navigationTitle: "Навигация по отчёту",
    loading: "Загрузка отчёта...",
    notFound: "Отчёт не найден.",
    dataUnavailable: "Данные отчёта пока недоступны.",
    backToDashboard: "Вернуться в личный кабинет",
    paywall: {
      eyebrow: "Бесплатный предпросмотр",
      title: "Всего один шаг до полного отчёта",
      description: "Данные по адресу {{address}} уже собраны и проанализированы. Вот что вы откроете:",
      findingsTitle: "Что мы нашли по этому объекту",
      estimateLabel: "Оценочная рыночная стоимость",
      estimateNote: "с диапазоном и уровнем надёжности",
      ceilingLabel: "Округлённый ориентир стоимости",
      ceilingNote: "округлённая отправная точка анализа с учётом ваших обстоятельств",
      salesLabel: "Совершённые сделки поблизости",
      salesYears: "{{from}}–{{to}}",
      salesClosest: "ближайшая в {{distance}} м",
      listingsLabel: "Сравнимые объявления",
      listingsNote: "средняя цена предложения за м²",
      gapLabel: "Цены в объявлениях и в сделках",
      gapNote: "разница между ценой в объявлении и ценой продажи поблизости",
      argumentsLabel: "Аргументы для торга",
      argumentsNote: "с листом для печати на просмотр",
      riskLabel: "Проверьте до подписания",
      riskNote: "Что именно сделать, сказано в полном отчёте.",
      includesTitle: "Полный отчёт содержит",
      includes: {
        estimate: "Информативную оценку стоимости с диапазоном и уровнем надёжности",
        method: "Пошаговый расчёт по официальным данным",
        sales: "Совершённые сделки (ETN) на карте с ценами и датами",
        trend: "График динамики цен в районе по годам",
        listings: "Сравнимые объявления с ценами и ссылками",
        location: "Анализ локации и инфраструктуры рядом",
        cadaster: "Ключевые характеристики здания и кадастровые данные",
        risks: "Список рисков и шаги перед подписанием договора",
        negotiation: "Аргументы для торга и лист для печати на просмотр",
        attachments: "Приложения: оценка GURS и кадастровая выписка",
        attachmentsEnergy: "Приложения: оценка GURS, кадастровая выписка и энергетический паспорт",
        pdf: "Полный PDF для скачивания и печати",
      },
      priceNote: "Разовый платёж · без подписки",
      buyCta: "Открыть полный отчёт",
      instant: "Полный отчёт с выпиской из земельной книги мы доставим в течение 1 рабочего дня.",
      heldTitle: "Оплачено — мы готовим полный отчёт",
      secure: "Безопасная оплата картой через Stripe",
      sample: "Посмотреть пример полного отчёта (PDF)",
      bundle: "Смотрите несколько объектов? 5 отчётов за {{price}} ({{per}} за отчёт)",
      stickyLabel: "Бесплатный предпросмотр",
      stickyCta: "Открыть за {{price}}",
      unlockCta: "Открыть отчёт (1 кредит)",
      unlocking: "Открываем...",
      creditsAvailable: "У вас доступно купленных кредитов: {{count}}",
      unlockedTitle: "Отчёт открыт",
      unlockedDesc: "Полный отчёт теперь доступен.",
      unlockedPdfPending: "Отчёт открыт. Полный PDF ещё готовится — повторите загрузку через мгновение.",
      unlockFailedTitle: "Не удалось открыть",
      downloadPreview: "Скачать предпросмотр",
    },
    attachments: {
      title: "Приложения",
      description:
        "Исходные документы к этому отчёту (также включены в загружаемый PDF).",
      valuation: "Оценка недвижимости (GURS)",
      cadastral: "Кадастровая выписка (GURS)",
      energy: "Энергетический сертификат",
      uploaded: "Загруженный документ",
    },
    badge: "Отчёт nReport.ai о недвижимости",
    title: "Анализ недвижимости",
    sectionOverviewEyebrow: "Обзор недвижимости",
    sectionOverviewTitle: "Ключевые характеристики",
    sectionOverviewDesc:
      "Тип и назначение объекта, расположение в здании, планировка, конструкция и оснащение.",
    sectionFeaturesEyebrow: "Сводка",
    sectionFeaturesTitle: "Ключевые показатели",
    sectionMarketEyebrow: "AI-рыночный анализ",
    sectionMarketTitle: "Расширенный рыночный анализ",
    sectionMarketDesc:
      "Комплексный рыночный анализ с использованием AI и статистических моделей.",
    sectionMethodologyEyebrow: "Методология",
    sectionMethodologyTitle: "Информативная стоимость",
    sectionMethodologyDesc:
      "Взвешенная оценка, которая согласует официальную стоимость GURS с ценами объявлений и реализованных сделок.",
    sectionLocationEyebrow: "Локация",
    sectionLocationTitle: "Местоположение в контексте",
    sectionLocationDesc: "Анализ местоположения недвижимости и окружения.",
    sectionCadasterEyebrow: "Земельный кадастр",
    sectionCadasterTitle: "Анализ выписки из земельного кадастра",
    sectionValuationEyebrow: "Оценка недвижимости",
    sectionValuationTitle: "Официальная стоимость недвижимости",
    sectionValuationDesc: "Обобщённая рыночная стоимость здания и земли по GURS.",
    sectionEtnEyebrow: "История сделок",
    sectionEtnTitle: "Завершённые сделки поблизости",
    sectionEtnDesc:
      "Обзор завершённых продаж сопоставимых объектов из реестра ETN.",
    sectionAdsEyebrow: "Обзор рынка",
    sectionAdsTitle: "Сопоставимые объявления",
    sectionAdsDesc: "Отобранные объявления с наиболее сопоставимыми показателями.",
    sectionAdsDescCohort:
      "Репрезентативная выборка из {{shown}} от {{total}} объявлений, вошедших в анализ цен предложения. Среднее, диапазон и надёжность рассчитаны по всем {{total}}.",
    adsScopeTitle: "Как отбирались сопоставимые объявления",
    recommendations: "Рекомендации",
    priceAnalysis: "Ценовой анализ",
    marketPosition: "Положение на рынке",
    propertyCharacteristics: "Характеристики недвижимости",
    investmentInsights: "Инвестиционные выводы",
    buildingValuation: "Оценка здания",
    landValuation: "Оценка земли",
    satelliteMap: "Спутниковый вид",
    streetView: "Street View",
    disclaimerTitle: "Правовое уведомление",
    disclaimerText:
      "Настоящий отчёт предназначен исключительно для информационных целей и не является официальной оценкой недвижимости. Данные и анализы основаны на общедоступных записях и статистических моделях, которые не заменяют профессиональную оценку лицензированного оценщика.",
    area: "Площадь",
    netArea: "Чистая площадь",
    usableArea: "Полезная площадь",
    landArea: "Площадь земли",
    yearBuilt: "Год постройки",
    metricInformativeValue: "Информативная стоимость",
    metricGursValue: "Обобщённая стоимость GURS",
    metricMarketPriceM2: "Рыночная оценка (объявления)",
    metricEtnPriceM2: "Реализованная стоимость (ETN)",
    metricEtnGrowth: "Годовой рост цен (CAGR)",
    metricEtnGrowthHint: "Исторический рост реализованных цен за м² поблизости ({{period}}). Это не доходность от аренды и не прогноз.",
    metricEtnHistoricalHint:
      "Среднее по более старым сделкам — в последний период сопоставимых продаж нет, поэтому в оценку не входит.",
    metricEtnGrowthHintNoPeriod:
      "Исторический рост реализованных цен за м² поблизости. Это не доходность от аренды и не прогноз.",
    gursGapLabel: "Разница с GURS",
    distributionTitle: "Оценка рядом с договорными ценами сделок",
    distributionLead:
      "Показаны договорные цены за м² и информационная оценка. Эти договорные цены не приведены к дате или модельной основе оценки; сама разница не доказывает скидку или завышение цены.",
    distributionAlt: "Распределение реализованных цен за м²",
    negotiationSheetDownload: "Переговорный лист",
    negotiationEyebrow: "Переговорный лист",
    negotiationTitle: "Аргументы, подкреплённые данными",
    negotiationDesc:
      "Каждый аргумент ниже основан на данных этого отчёта и указывает свой источник. Они предназначены для того, чтобы их произносили вслух, а не объясняли.",
    negotiationCeilingLabel: "Округлённый ориентир стоимости",
    negotiationBatna:
      "Определите личную максимальную цену предложения с учётом бюджета, расходов на покупку и ремонт, а также нерешённых вопросов. Она может отличаться от ориентира анализа.",
    negotiationSourcePrefix: "Источник:",
    negotiationHowToTitle: "Как использовать эти аргументы",
    negotiationHowTo: [
      "Не начинайте с цены. Спросите: «Как вы пришли к этой цене?» Дайте продавцу объяснить, затем покажите данные.",
      "Показывайте, а не требуйте: «Я посмотрел реализованные сделки поблизости — сопоставимые объекты продавались за X. Как вы объясняете разницу?»",
      "Не оправдывайте своё предложение. Оно подкреплено данными; ваш аргумент — документ, а не вы.",
      "Назвав цифру, замолчите. Тишина — переговорный инструмент.",
      "Если слышите «это ниже рынка», спросите: «Какие реализованные сделки это подтверждают?»",
    ],
    negotiationLimitsTitle: "Ограничения.",
    negotiationLimits:
      "Анализ основан на общедоступных реестрах (GURS, ETN, площадки объявлений) и не заменяет официальную оценку. Реализованные сделки — лучший доступный ориентир рыночной стоимости, но не абсолютная истина. Исход переговоров зависит также от мотивации продавца, условий финансирования и факторов, которые этот анализ не может предвидеть.",
    keyFactsEyebrow: "Основные данные",
    keyFactsTitle: "Объект с одного взгляда",
    addressSpreadTitle: "Диапазон зарегистрированных цен по одному адресу",
    addressSpreadAnd: "и",
    addressSpreadExplain:
      "Сделки по одному адресу могут относиться к разным частям здания, датам продажи и условиям договора. Сам диапазон цен не подтверждает ни сопоставимость, ни ошибку данных. Реестр не позволяет установить полную причину различий; учитывайте указанные данные и ограничения каждой сделки.",
    selectionNoteTitle: "Как отбирались сопоставимые сделки.",
    selectionNote:
      "В радиусе {{radius}} км мы просмотрели {{considered}} реализованных сделок и использовали {{used}} из них. Учитывались сделки с площадью от {{min}} до {{max}} м².",
    selectionNoteNoSize:
      "В радиусе {{radius}} км мы просмотрели {{considered}} реализованных сделок и использовали {{used}} из них. Площадь этого объекта в GURS не указана, поэтому сделки не фильтровались по площади и сопоставимость по размеру не гарантирована.",
    selectionNoteLandRatio: "Для домов мы дополнительно требовали схожее соотношение участка и строения.",
    selectionNoteOutliers:
      "{{count}} сделок исключены как статистические выбросы — цена за м² настолько выходила за локальный диапазон, что вероятнее всего это нерыночная передача.",
    selectionNoteCohort:
      "Для оценки использованы {{used}} из {{considered}} проверенных сделок в радиусе {{radius}} км — заключённые за {{months}} месяцев до даты оценки ({{date}}).",
    selectionNoteCohortNone:
      "Ни одна из {{considered}} проверенных сделок в радиусе {{radius}} км не является сопоставимой сделкой за {{months}} месяцев до даты оценки ({{date}}), поэтому реализованные продажи в оценку не входят.",
    selectionNoteSizeBand:
      "Учитывались сделки с площадью от {{min}} до {{max}} м².",
    selectionNoteNoSizeShort:
      "Площадь этой недвижимости в GURS не указана, поэтому сделки не отбирались по размеру.",
    selectionNoteHistorical:
      "{{count}} более старых сопоставимых сделок показаны только как исторический контекст (помечены как старые); в оценку они не входят.",
    selectionNoteExcluded:
      "Исключено: {{count}}",
    selectionExclIneligible:
      "{{count}} не подходят как сопоставимые (напр. продажа доли, сделки между связанными лицами)",
    selectionExclNotComparable:
      "{{count}} по площади, соотношению участка и строения или цене",
    selectionExclOutliers:
      "{{count}} статистических выбросов",
    selectionExclDate:
      "{{count}} без корректной даты или дубликаты",
    evidence: {
      eyebrow: "Доказательства для оценки",
      title: "Самые близкие сопоставимые сделки и путь к оценке",
      desc: "Какие реализованные сделки больше всего похожи на этот объект, чем они отличаются и как из наблюдаемых цен получается оценка.",
      headlinePriced: "Показаны {{shown}} самых похожих из {{priced}} сделок в оценке; оценку определяют все они, а не только показанные.",
      headlineThin: "В оценке лишь {{priced}} реализованных сделки(-ок) за последние 24 месяца: данных мало.",
      headlineHistorical: "За последние 24 месяца нет сопоставимой реализованной сделки; более старые сделки ниже — лишь исторический контекст.",
      headlineNoSales: "Поблизости нет сопоставимой реализованной сделки.",
      headlineNoArea: "Информативная стоимость не рассчитана, так как площадь объекта в GURS не указана.",
      headlineNoRecent: "Информативная стоимость не рассчитана: за последние 24 месяца нет сопоставимой реализованной сделки и нет сопоставимых объявлений.",
      headlineWithheld: "Информативная стоимость не опубликована: сопоставимых сделок слишком мало или они слишком разбросаны для надёжной оценки.",
      headlineContextSuffix: "Более старые сделки ниже — лишь исторический контекст.",
      colSale: "Сделка",
      colDate: "Дата",
      colDistance: "Расстояние",
      colArea: "Площадь",
      colPrice: "Цена",
      colPricePerM2: "Цена/м²",
      colSimilarity: "Сходство",
      sourceId: "ID сделки ETN {{id}}",
      typeApartment: "квартира",
      typeHouse: "дом",
      addressUnknown: "Адрес не опубликован",
      atValuationDate: "на дату оценки {{price}}",
      contextMarker: "более старая сделка — только контекст",
      yearOnly: "{{year}} год",
      knownDifferences: "Известные различия",
      dealNotes: "Особенности сделки",
      areaBasis: "База площади",
      areaBasisDwelling: "проданная чистая площадь жилой единицы",
      areaBasisAllParts: "проданная площадь всех частей сделки",
      diffSizeSimilar: "похожая площадь ({{area}})",
      diffSizeLarger: "больше на {{pct}} ({{area}})",
      diffSizeSmaller: "меньше на {{pct}} ({{area}})",
      diffSizeUnknownSubject: "{{area}}; площадь этого объекта неизвестна",
      diffYearSame: "построен в то же время ({{year}})",
      diffYearNewer: "новее на {{years}} лет ({{year}})",
      diffYearOlder: "старше на {{years}} лет ({{year}})",
      diffYearUnknown: "год постройки неизвестен",
      diffYearUnknownSubject: "построен в {{year}}; год постройки этого объекта неизвестен",
      diffLandSimilar: "похожий участок ({{area}})",
      diffLandMore: "участок больше на {{pct}} ({{area}})",
      diffLandLess: "участок меньше на {{pct}} ({{area}})",
      diffLandUnknownSubject: "участок {{area}}; участок этого объекта неизвестен",
      diffLandNone: "участок в сделке не указан",
      flags: {
        ancillary_included: "цена включает гараж, парковочное место или кладовую (не в м²)",
        outbuildings_included: "цена включает вспомогательные или хозяйственные постройки",
        minor_extra_land: "сделка включает небольшой дополнительный участок",
        shared_land: "участок продан как доля в совместной собственности",
        vat_included: "цена включает НДС",
        vat_rate_mixed: "цена включает НДС по разным ставкам",
        new_build: "новостройка",
        voluntary_auction: "продажа на добровольном аукционе",
        gurs_market_data_issue: "GURS: рыночная сделка с неполными данными",
        gurs_unverified: "ещё не проверено GURS",
      },
      priceAdjustment: "Корректировка цены",
      adjSize: "площадь {{pct}}",
      adjAge: "год постройки {{pct}}",
      adjTotal: "итого {{pct}}",
      adjNone: "без корректировки (площадь и год постройки совпадают или неизвестны)",
      setTitle: "Показанные сделки и весь анализ.",
      setWeighting: "В среднее ETN входят все сделки за последние {{months}} месяцев ({{priced}}), а не только показанные, взвешенные по площади (сумма цен / сумма м²).",
      setWeightsAsking: "Реализованные сделки составляют {{etn}} % оценки, цены предложения ({{listings}} объявлений) — остальное.",
      setWeightsOnly: "Реализованные сделки составляют {{etn}} % оценки.",
      setEtnZero: "В этой оценке реализованные сделки не имеют веса.",
      setNone: "Ни одна реализованная сделка не вошла в оценку.",
      setAverages: "Среднее показанных сделок — {{shown}}, всех сделок в оценке ({{priced}}) — {{all}}.",
      setExcluded: "Исключено {{excluded}} из {{considered}} рассмотренных сделок; причины указаны при отборе сделок.",
      similarityMethod: "Сходство (0–100) рассчитывается по расстоянию, разнице чистой площади, разнице года постройки, давности сделки и, для домов, разнице площади участка. Отсутствующий показатель считается как половинное несовпадение. Тип объекта совпадает у всех сделок, так как отбираются только сделки того же типа.",
      bridgeTitle: "От наблюдаемых цен к оценке",
      legs: {
        etn: "Реализованные сделки (ETN)",
        market: "Цены предложения",
        gurs: "Обобщённая стоимость GURS",
      },
      weight: "вес {{pct}} %",
      observedEtn: "Наблюдаемое: сумма цен / сумма м² всех {{n}} сделок в оценке",
      observedMarket: "Наблюдаемое: средняя цена предложения {{n}} объявлений в анализе",
      observedGurs: "Наблюдаемое: обобщённая стоимость GURS / площадь для расчёта оценки",
      steps: {
        etn_time_index: "Корректировка на дату оценки {{pct}} (измерено: местное годовое изменение цен по тем же сделкам)",
        etn_uplift: "Повышение цен ETN {{pct}} (допущение модели, независимо не проверено)",
        asking_haircut_measured: "Снижение цен предложения {{pct}} (измеренное соотношение предложение/сделка; вероятно, верхняя граница)",
        asking_haircut_assumed: "Снижение цен предложения {{pct}} (допущение, меньше измеренной разницы)",
        gurs_uplift: "Повышение обобщённой стоимости GURS {{pct}} (допущение модели, независимо не проверено)",
        etn_comparable_adjustments: "Корректировка сопоставимых сделок на различия в площади и годе постройки {{pct}} (измерено на зарегистрированных сделках; корректировка каждой сделки указана при сделке)",
        subject_position: "Этаж и лифт {{pct}} (официальный коэффициент расположения GURS для этой квартиры; этажи сопоставимых сделок не зарегистрированы)",
      },
      statusMeasured: "измерено",
      statusAssumed: "допущение",
      effectOnEstimate: "Влияние на оценку: {{eur}}",
      contribution: "Вклад в оценку: {{price}} × {{share}}",
      downweight: "Вес реализованных сделок умножен на {{value}}, так как скорректированные цены предложения значительно выше (допущение модели, независимо не проверено).",
      weightedPrice: "Взвешенная цена за м²",
      roundedFrom: "округлено с {{value}}",
      timesArea: "× {{label}} {{area}} = информативная стоимость",
      noSubjectAdjustments: "Оценка не корректирует различия между сопоставимыми сделками и этим объектом (площадь, возраст, участок, состояние, энергокласс, этаж): ни для одного из них нет проверенного местного коэффициента. Различия указаны, но не оценены.",
      subjectAdjustmentsSizeAge: "Различия в площади и годе постройки оценены коэффициентами, измеренными на зарегистрированных сделках (меньшие квартиры продаются дороже за м²); корректировка каждой показанной сделки указана при сделке.",
      subjectAdjustmentsPosition: "Этаж и лифт учитываются официальным коэффициентом расположения GURS для этой квартиры.",
      subjectAdjustmentsRest: "Участок, состояние и энергокласс не оцениваются: для них нет измеренного коэффициента.",
      subjectAdjustmentsRestNoSizeAge: "Площадь, возраст, участок, состояние и энергокласс не оцениваются: для них нет измеренного местного коэффициента; различия указаны при сделках.",
      rangeNote: "Диапазон {{min}} – {{max}} описан в методологии.",
      mismatch: "Несоответствие:",
      driversTitle: "Что сильнее всего влияет на оценку",
      driverSource: "{{label}}: {{pct}} % оценки — {{price}} после корректировок, вклад {{eur}}",
      driverStep: "{{step}}: {{eur}} к оценке",
      unpricedTitle: "Что оценка не учитывает",
      unpricedTitleNoEstimate: "Чего не охватывает сравнение со сделками",
      unpriced: {
        condition: "Состояние и ремонты: нет данных ни по этому объекту, ни по сопоставимым сделкам, поэтому разница не оценена. Отремонтированный объект или требующий ремонта может существенно отличаться от оценки.",
        energy: "Энергокласс: в реестре сделок нет данных по сопоставимым сделкам, поэтому разница не оценена.",
        floor: "Этаж и лифт: в реестре сделок нет данных, поэтому разница не оценена.",
        floor_position: "Этаж и лифт: в реестре сделок нет данных по сопоставимым сделкам; для этого объекта применён официальный коэффициент расположения GURS, но разница с каждой отдельной сделкой не оценена.",
        land: "Участок: различия в площади и использовании участка указаны для каждой сделки, но не оценены.",
        land_unknown: "Участок: площадь участка этого объекта неизвестна, поэтому сравнение невозможно.",
        package_contents: "Состав сделки: в некоторых сделках цена включает гараж, парковку или постройки, площадь которых не входит в м²; их стоимость не вычтена.",
      },
      nextStepsTitle: "Что проверить дальше",
      nextSteps: {
        get_area: "Получите чистую площадь единицы (кадастр зданий GURS, проектная документация или продавец); без неё оценку рассчитать нельзя.",
        appraisal_no_recent_sales: "Для текущей стоимости закажите оценку у судебного оценщика: за последние 24 месяца нет сопоставимой реализованной сделки, а старые цены — не сегодняшняя стоимость.",
        appraisal_withheld: "Для надёжной стоимости закажите оценку у судебного оценщика: сопоставимых сделок слишком мало или они слишком разбросаны.",
        thin_evidence: "Оценка опирается на очень мало реализованных сделок; одна нетипичная сделка может сильно её сдвинуть. До обязывающего предложения получите дополнительные сравнения или оценку.",
        no_recent_sales: "За последние 24 месяца нет сопоставимой реализованной сделки; для текущего уровня цен опирайтесь на оценку или проверенные согласованные цены поблизости.",
        inspect_condition: "Проверьте состояние, ремонты и энергокласс на осмотре и в энергетическом сертификате — это главные различия, которые оценка не учитывает.",
        size_spread: "Большинство показанных сделок отличаются по площади на 20 % и более; цена за м² у меньших объектов обычно выше, у больших — ниже.",
        house_parcels: "Проверьте, какие участки и постройки входят в продажу (земельная книга, кадастровый план), и сравните их со сделками выше.",
        etn_unweighted: "Реализованные сделки в этой оценке не имеют веса (она опирается на цены предложения); спросите у продавца или агента достигнутые цены сопоставимых объектов.",
      },
    },
    actionEyebrow: "Следующие шаги",
    actionTitle: "Что проверить до подписания",
    actionDesc:
      "Порядок выбран намеренно: сначала то, что мы не смогли проверить по этому объекту, затем стандартные проверки при любой покупке.",
    limitationsTitle: "Ограничения этого отчёта",
    limitationsIntro: "Некоторые данные не удалось получить или проверить при составлении отчёта. Ниже указано, чего не хватает, почему и что вы можете сделать. Остальные данные взяты из указанных публичных реестров и объявлений по состоянию на момент составления отчёта; ошибки в самих реестрах исключить нельзя.",
    limitationsRecovery: "Что вы можете сделать:",
    qualityReviewNotice: "Этот отчёт проверяется, так как автоматическая проверка качества не подтвердила все его данные. Пожалуйста, не опирайтесь на цифры до завершения проверки.",
    execTitle: "Краткое резюме",
    cadastralIdentity: { building: "Здание", apartment: "Квартира", part: "Кадастровая часть", parcel: "Участок", municipality: "Кадастровая община" },
    scopeWholeTitle: "Объект оценки: всё здание",
    scopePartTitle: "Объект оценки: отдельная часть здания",
    scopeParts: "Учтённые части здания",
    scopeAreaParts: "Части, площадь которых использована в оценке",
    scopeWholeNote: "Если вы покупаете только часть дома, не применяйте к ней оценку всего здания. Уточните, какие части включены в продажу.",
    scopePartNote: "Этот анализ касается указанной части, а не всего здания. Убедитесь, что вы покупаете именно эту часть.",
    execValue: "Ориентировочная оценка стоимости",
    execGursOnlyValue: "Ориентир на основе GURS",
    execRangePrefix: "Ориентировочный модельный диапазон",
    execRangeNote: "Диапазон не гарантирует, что итоговая цена продажи окажется в его пределах, и не является диапазоном торга.",
    execInterpretations: {
      high: "Оценка подкреплена сопоставимыми завершёнными продажами. Она не определяет максимальную разумную цену предложения: решение зависит также от состояния объекта, расходов и вашего бюджета.",
      medium: "Оценка использует доступные источники с указанными ограничениями. До обязывающего предложения проверьте сопоставимость, состояние и расходы; сумма не является верхней границей предложения.",
      low: "Оценка носит преимущественно ориентировочный характер. До обязывающего предложения рекомендуется дополнительная проверка.",
      gurs_only: "Сумма основана только на GURS с предполагаемой модельной корректировкой. Пригодных сопоставимых продаж или объявлений нет, поэтому это лишь ориентир. До обязывающего предложения закажите независимую оценку.",
      limits: "Причины ограниченной надёжности:",
    },
    execCeiling: "Округлённый ориентир стоимости",
    execCeilingNote: "Округлённая отправная точка анализа. Диапазон оценки отражает неопределённость, а не диапазон торга.",
    execTopRisk: "Главный риск",
    execNoRisk: "Открытых замечаний нет",
    execDisclaimer:
      "Информационный отчёт для более взвешенных решений — он не заменяет официальную оценку.",
    riskEyebrow: "Статус проверки",
    propertyChecks: propertyChecksRu,
    supportingDocuments: supportingDocumentsRu,
    riskTitle: "Что проверено, а что нет",
    riskDesc:
      "Этот анализ основан на публичных реестрах. Ниже прямо указано, что мы смогли проверить, что — нет, и что стоит проверить до подписания.",
    appraisalTitle: "Перед обязывающим предложением",
    appraisalBeforeOffer: "до предложения",
    confidenceTitle: "Надёжность оценки",
    confidenceHigh: "Высокая",
    confidenceMedium: "Умеренная",
    confidenceLow: "Низкая",
    confidenceHighNote:
      "Поблизости достаточно сопоставимых реализованных сделок и объявлений, чтобы оценка была надёжно обоснована. У покупателя есть надёжная основа для переговоров, у продавца — для определения цены.",
    confidenceMediumNote:
      "Оценка опирается на доступные источники, но возможны отклонения. Используйте её как ориентир, а не как точную цифру, и закладывайте более широкий диапазон при переговорах.",
    confidenceLowNote:
      "Данные об объекте или рынке имеют ограничения, поэтому оценка служит ориентиром. Причины и исходные данные приведены ниже; перед важным решением рекомендуем дополнительную проверку или независимую оценку.",
    confidenceLimits: {
      few_comparable_sales: "Мало сопоставимых реализованных сделок",
      wide_comparable_spread: "Большой разброс цен сопоставимых сделок",
      very_wide_comparable_spread: "Очень большой разброс цен сопоставимых сделок",
      stale_comparable_sales: "Более старые сопоставимые сделки",
      very_stale_comparable_sales: "Очень старые сопоставимые сделки",
      sources_disagree: "Источники цен расходятся",
      sources_disagree_strongly: "Источники цен сильно расходятся",
      house_segment: "Дома сильнее различаются по состоянию, участку и возрасту",
      subject_area_unconfirmed: "Площадь не подтверждена несколькими источниками",
      subject_data_limited: "Ограниченные данные об объекте или площади оценки",
      asking_evidence_weak: "Более широкий охват объявлений или ограниченная сопоставимость",
      gurs_only: "Оценка основана только на модельном ориентире GURS",
    },
    confidenceComparables: "Сопоставимые реализованные сделки",
    confidenceListings: "Сопоставимые активные объявления",
    confidenceListingQuality: "Качество данных объявлений",
    confidenceDispersion: "Разброс цен сопоставимых сделок",
    confidenceDataAge: "Давность последней сделки",
    confidenceMonths: "{{count}} мес.",
    avgPrice: "Средняя цена",
    medianPrice: "Медианная цена",
    minPrice: "Минимальная цена",
    maxPrice: "Максимальная цена",
    pricePerM2: "Цена за м²",
    propertyValue: "Стоимость недвижимости",
    marketAverage: "Цены предложения, пересчитанные на эту площадь",
    askingHaircut: "Учтённая скидка от цены предложения",
    differenceFromAsking: "Отклонение от цен предложения за м²",
    pricePercentile: "Ценовой процентиль",
    marketSegment: "Ценовая группа среди объявлений",
    positionValueLabel: "Сравниваемый расчёт",
    marketSegmentLabels: {"budget": "Нижняя четверть", "average": "От 25-го до 50-го процентиля", "premium": "От 50-го до 75-го процентиля", "luxury": "Верхняя четверть"},
    avgSize: "Средний размер",
    avgYearBuilt: "Средний год постройки",
    newerProperties: "Более новые объекты",
    olderProperties: "Более старые объекты",
    askingVsSold: "Разница между запросом и продажей",
    negotiationPotential: "Потенциал для переговоров",
    negotiationNotAssessed: "Не оценивается. Разница между ценами объявлений и сделок не определяет скидку для этого объекта.",
    marketLiquidity: "Ликвидность рынка",
    gursGeneralized: "Обобщённая стоимость GURS",
    landGursValue: "Стоимость земли по GURS",
    analyzedDeals: "Проанализированные сделки",
    avgEtnPrice: "Средняя цена",
    priceTrend: "Ценовой тренд",
    closestDeal: "Ближайшая сделка",
    year: "Год",
    transactions: "Сделки",
    avgPriceM2: "Сред. цена/м²",
    medianPriceM2: "Медиана цены/м²",
    change: "Изменение",
    overallGrowth: "Общий рост",
    annualizedGrowth: "Годовой рост (CAGR)",
    comparableArea: "Сопоставимая площадь (чистая, подсобные помещения с весом)",
    comparableAreaShort: "Сопоставимая площадь",
    valuedOnArea: "{{price}} × сопоставимая площадь {{area}}",
    comparableAreaFlat: "Сопоставимая площадь = (полезная {{usable}} + {{weight}} × подсобные помещения {{ancillary}}) / {{ratio}}{{unallocated}} = {{area}} (чистая площадь {{net}}).",
    comparableAreaUnallocated: " + нераспределённые помещения {{area}}",
    comparableAreaHouse: "Сопоставимая площадь = чистая {{net}} − подсобные помещения {{ancillary}} + {{weight}} × {{ancillary}} = {{area}}: террасы и подвалы учитываются с меньшим весом, чем средний м² сопоставимых домов.",
    comparableAreaHouseNoAncillary: "Сопоставимая площадь равна чистой площади {{net}} (GURS не указывает террас или подвалов).",
    comparableAreaWhy: "Цены сопоставимых сделок указаны за м² чистой площади, включающей и их подвалы и балконы, поэтому подсобные помещения с обеих сторон учитываются с одинаковым весом.",
    growthCaveatNote: "‡ Изменение более чем на 25 % за один год ({{years}}) в этой местной выборке, скорее всего, отражает другой состав проданных объектов (площадь, возраст, новостройки), а не реальное движение цен.",
    anomalyNote:
      "* Год с очень небольшим числом сделок и ценой, сильно отличающейся от среднего по округе, — как правило, это одна нетипичная сделка (продажа доли, сделка между связанными лицами или объект другой категории). Мы её показываем, но не учитываем в расчёте роста.",
    address: "Адрес",
    price: "Цена",
    distance: "Расстояние",
    dealDate: "Дата сделки",
    indexedPricePerM2: "На дату оценки",
    indexedPriceNote:
      "На дату оценки {{date}}: реализованная цена, пересчитанная на эту дату по оценочному локальному годовому изменению {{rate}}. Исходные цены старых сделок нельзя напрямую сравнивать с ценами объявлений за период отчёта. Сделки старше пяти лет на дату оценки не индексируются. † отмечает более старую сделку, не включённую в оценку.",
    adDescription: "Описание",
    adPriceLevel: "Уровень цены",
    adPriceBelow: "Ниже уровня объявлений",
    adPriceWithin: "На уровне объявлений",
    adPriceAbove: "Выше уровня объявлений",
    adLocation: "Локация",
    link: "Ссылка",
    openAd: "Открыть объявление",
    na: "Н/Д",
    paginationPrevious: "Назад",
    paginationNext: "Далее",
    paginationShowing: "Показано {{from}}–{{to}} из {{total}}",
    filtersTitle: "Фильтры",
    filterMin: "Мин",
    filterMax: "Макс",
    filtersClear: "Сбросить",
    mapSubject: "Оцениваемый объект",
    mapComparablesTitle: "Сопоставимые продажи на карте",
    share: {
      button: "Поделиться",
      title: "Поделиться отчётом",
      description: "Любой, у кого есть эта ссылка, может просмотреть отчёт. Вход не требуется.",
      notCompleted: "Вы сможете поделиться отчётом, когда он будет готов.",
      generate: "Создать ссылку",
      generating: "Создание…",
      linkLabel: "Публичная ссылка",
      copy: "Копировать",
      copied: "Скопировано!",
      revoke: "Отозвать доступ",
      revoking: "Отзыв…",
      notShared: "Этот отчёт ещё не опубликован.",
      error: "Что-то пошло не так. Попробуйте ещё раз.",
    },
    sharedCta: "Создайте свой отчёт",
    sharedClosingTitle: "Проверьте другой объект",
    sharedClosingText:
      "Этот отчёт кто-то подготовил по конкретному адресу. Такую же проверку вы можете сделать для любого адреса в Словении — первый отчёт бесплатный.",
    sharedClosingCta: "Проверить свой объект",
    sharedUnavailableTitle: "Отчёт недоступен",
    sharedUnavailableText: "Эта ссылка на отчёт больше не доступна.",
    intel: {
      eyebrow: "Локальный рынок объявлений",
      title: "Аналитика рынка района",
      desc: "Анализ активных объявлений по сопоставимым объектам поблизости (nepremicnine.net).",
      sampleNote: "На основе {{count}} активных объявлений ({{locality}}).",
      sampleNoteAsOf: "На основе {{count}} активных объявлений ({{locality}}), по состоянию на последний сбор {{date}}.",
      medianAsking: "Медианная цена предложения",
      askingRange: "Диапазон (P25–P75)",
      yourValue: "Ваша оценочная стоимость",
      percentile: "Позиция среди объявлений",
      pricingBelow: "Ваша стоимость за м² ниже большинства местных цен предложения.",
      pricingInline: "Ваша стоимость соответствует местным ценам предложения.",
      pricingAbove: "Ваша стоимость за м² выше большинства местных цен предложения.",
      newBuildShare: "Доля новостроек",
      priceDrops: "Снижения цен предложения",
      dropsDetail: "{{share}} объявлений, в среднем {{avg}}",
      observedAge: "Наблюдаемый возраст объявлений (медиана)",
      observedAgeValue: "{{days}} дн.",
      observedAgeLowerBound: "не менее {{days}} дн.",
      delisted: "Снятые объявления (последние 30 дней наблюдения)",
      delistedDetail: "{{delisted}} снято / {{active}} активно",
      activityOutage: "Сбор объявлений прерван с {{date}}, поэтому возраст объявлений и снятия не показываются; цены предложения отражают последний сбор.",
      activityShallow: "У архива объявлений пока нет достаточно длинной непрерывной истории, поэтому возраст объявлений и снятия не показываются.",
      activityNote: "Наблюдаемый возраст — это время между первым и последним сбором объявления в нашем архиве, а не дата первой публикации. Снятое объявление не означает продажу. Срок продажи мы не оцениваем, так как объявления нельзя связать с зарегистрированными сделками.",
    },
  },
  creditHistory: {
    title: "История кредитов",
    filterPlaceholder: "Фильтр по типу",
    filterAll: "Все транзакции",
    filterPurchase: "Покупки",
    filterUsage: "Использование",
    filterExpiring: "Скоро истекают",
    date: "Дата",
    noResults: "Нет результатов.",
    noResultsHint: "Попробуйте другие фильтры.",
    noTransactions: "Нет транзакций.",
    noTransactionsHint: "Ваши транзакции появятся здесь.",
    expired: "Истекло",
    expiresIn: "Истекает через {{days}} дн.",
    validUntil: "Действителен до",
  },
  creditBalance: {
    title: "Мои кредиты",
    available: "Доступные кредиты",
    refresh: "Обновить баланс",
  },
  embeddedCheckout: {
    loginRequired: "Для оплаты необходимо войти в систему.",
    createError: "Ошибка при создании платежа. Пожалуйста, попробуйте снова.",
    preparing: "Подготовка оплаты...",
    tryAgain: "Попробовать снова",
    successTitle: "Оплата прошла успешно!",
    successDesc: "Кредиты добавлены на Вашу учётную запись.",
  },
  checkoutModal: {
    eyebrow: "Оплата",
    purchase: "Покупка: {{name}}",
    purchaseCredits: "Покупка {{count}} кредитов",
  },
  ratePage: {
    backHome: "Вернуться на главную",
  },
  userRating: {
    title: "Как бы Вы оценили наш сервис?",
    subtitle: "Ваш отзыв помогает нам становиться лучше",
    rateAria: "Оценить {{star}} из 5",
    saveError: "Не удалось сохранить Вашу оценку.",
    thanksToast: "Спасибо!",
    thanksToastDesc: "Ваша оценка успешно сохранена.",
    thanks: "Спасибо за Вашу оценку!",
  },
  cookieConsent: {
    title: "Мы уважаем вашу конфиденциальность",
    description:
      "Строго необходимые файлы cookie используются для работы сайта. Аналитические и маркетинговые файлы cookie загружаются только с вашего согласия. Выбор можно изменить в любой момент.",
    cookiePolicyLink: "Политика файлов cookie",
    privacyPolicyLink: "Политика конфиденциальности",
    necessaryTitle: "Строго необходимые",
    necessaryDesc: "Вход, безопасность и оплата. Их нельзя отключить.",
    analyticsTitle: "Аналитические",
    analyticsDesc: "Измерение посещаемости и использования сайта для улучшения сервиса.",
    marketingTitle: "Маркетинговые",
    marketingDesc: "Измерение эффективности рекламы и показ более релевантных объявлений.",
    acceptAll: "Принять все",
    rejectAll: "Отклонить необязательные",
    customize: "Настройки",
    saveSelection: "Сохранить выбор",
  },
  withdrawal: {
    heading: "Перед оплатой: немедленное исполнение",
    explainer:
      "Отчёт — цифровое содержание, которое мы формируем сразу после оплаты. Закон о защите прав потребителей (статья 135 ZVPot-1) требует, чтобы вы прямо уполномочили нас начать исполнение немедленно и подтвердили, что тем самым утрачиваете 14-дневное право на отказ в отношении подготовленного отчёта. Неиспользованные кредиты возвращаются в течение 14 дней.",
    consentLabel:
      "Я согласен(на), что исполнение начинается немедленно, и подтверждаю, что после полного исполнения утрачиваю право на отказ от договора в отношении подготовленного отчёта.",
    termsPrefix: "Продолжая, вы принимаете:",
  },
  legal: legalRu,
};
